// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"DvSaUABH","ButtonSkeleton":"JLcqfpNy","IconPlaceholder":"isYh_Xez","Label":"f4yH2UA4"};